import { render, staticRenderFns } from "./CurriculaUsuario.vue?vue&type=template&id=d20c04a8&"
import script from "./CurriculaUsuario.vue?vue&type=script&lang=js&"
export * from "./CurriculaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CurriculaUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports